export interface AutoCompleteItem {
  label: string;
  value: string;
}

export interface AutoCompleteSelectEvent {
  item: AutoCompleteItem | undefined;
}

export interface AutoCompleteTextChange {
  text: string;
}

export interface AutoCompleteProps extends Partial<AutoCompleteOptions> {
  onTextChange?(event: AutoCompleteTextChange): void;
  onItemSelect?(event: AutoCompleteSelectEvent): void;
}

export interface AutoCompleteOptions {
  name: string;
  placeholder: string;
  menuItems: AutoCompleteItem[];
  text: string;
  height: number;
  noBorder: boolean;
}

export const AUTOCOMPLETE_DEFAULTS: AutoCompleteOptions = {
  name: '',
  placeholder: '',
  menuItems: [],
  text: '',
  height: 200,
  noBorder: false,
};
